import { getStartClashStatus } from "./index212.js";
function getEndClashCost(state, props) {
  if (props.lockEnds[0]) {
    return 0;
  }
  const action = state.sequence[0];
  if (!action)
    return 0;
  const diff = props.targetLength - state.totalLength;
  const startClosingDistance = props.endClosingDistances[0];
  const startEntranceDistance = props.endEntranceDistances[0];
  if (!getStartClashStatus({ action, startClosingDistance, startEntranceDistance, diff })) {
    return 1e6;
  } else {
    return 0;
  }
}
export {
  getEndClashCost
};
//# sourceMappingURL=index202.js.map
